module.exports = new __parcel__URL__("line-chart-production.cf5ea457.svg").toString();